import {
  DialogBody,
  DialogFooter,
  DialogFooterActions,
} from '_core/dialogs/dialog';
import { FinalForm } from '_core/final-form/finalForm';
import { DialogForm } from '_core/forms/dialogForm';
import { FormErrors } from '_core/forms/formErrors';
import { DateInputInFormGroupForFinalForm } from '_core/inputs/dateInput';
import { Button, Intent } from '@blueprintjs/core';
import { SubmissionErrors } from 'final-form';
import * as React from 'react';

export interface IMarkPlannedDialogFormValues {
  paymentPlanned: Date | null;
}

interface IProps {
  initialValues: IMarkPlannedDialogFormValues;
  isOpen: boolean;
  onClose: () => void;
  onClosed: () => void;
  onSubmit: (
    values: IMarkPlannedDialogFormValues
  ) => Promise<SubmissionErrors | void>;
}

export function InvoicesMarkPlannedDialogForm({
  initialValues,
  isOpen,
  onClose,
  onClosed,
  onSubmit,
}: IProps) {
  return (
    <FinalForm initialValues={initialValues} onSubmit={onSubmit}>
      {({ error, handleSubmit, submitError, submitting }) => (
        <DialogForm
          isOpen={isOpen}
          isSubmitting={submitting}
          title="Укажите план оплаты"
          onClose={onClose}
          onClosed={onClosed}
          onSubmit={handleSubmit}
        >
          <DialogBody>
            <FormErrors error={error || submitError} />

            <DateInputInFormGroupForFinalForm
              id="paymentPlanned"
              label="План оплаты"
              name="paymentPlanned"
            />
          </DialogBody>

          <DialogFooter>
            <DialogFooterActions>
              <Button text="Отмена" onClick={onClose} />

              <Button
                disabled={submitting}
                intent={Intent.PRIMARY}
                loading={submitting}
                text="Ок"
                type="submit"
              />
            </DialogFooterActions>
          </DialogFooter>
        </DialogForm>
      )}
    </FinalForm>
  );
}
